import { faCalendar } from "@fortawesome/pro-regular-svg-icons/faCalendar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Calendar: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faCalendar} {...props} />;
};
